module.exports = __webpack_public_path__ + "static/media/ws08.e64ece3f.webp";